<ng-container *ngIf="viewModel$ | async as viewModel">
  <!-- <div class="avatar" [class.message]="true" [class.system]="false">
      <p-avatar
          *ngIf="true"
          class="avatar-hover"
          [label]="comment.author | userInitials"
          (click)="viewAuthorInSidePanel(comment.author)"
      ></p-avatar>

      <span class="pin" *ngIf="false"></span>
  </div> -->

  <div class="system-content-container" *ngIf="viewModel.commentMode.system">
    <quill-editor
      class="content viewMode"
      [readOnly]="true"
      [ngModel]="viewModel.systemContents"
      (onEditorCreated)="attachHandlers($event)"
      format="object"
      [modules]="viewModules"
    ></quill-editor>

    <ng-container *ngTemplateOutlet="commentAttachments"></ng-container>
  </div>

  <div
    class="content-container message"
    *ngIf="!viewModel.commentMode.system"
    [class.reply]="!!viewModel.comment.parentId"
  >
    <div class="content-header">
      <div>
        <a
          class="userName"
          *ngIf="viewModel.comment.author"
          (click)="
            store.dispatch(
              actions.authorNameClicked({ userId: viewModel.comment.author.id })
            )
          "
        >
          {{ viewModel.comment.author | userName }}
          <span
            *ngIf="
              viewModel.comment.authorName &&
              (viewModel.comment.author | userName) !==
                viewModel.comment.authorName
            "
          >
            &nbsp;({{ viewModel.comment.authorName }})
          </span>
        </a>
        <a
          class="authorName"
          *ngIf="!viewModel.comment.author && viewModel.comment.authorName"
        >
          {{ viewModel.comment.authorName }}
        </a>
        ·
        <app-time-since
          [unixTime]="viewModel.comment.createdAt / 1000"
        ></app-time-since>

        <i
          class="pi pi-spin pi-spinner"
          *ngIf="viewModel.comment.callState === 'MUTATING'"
        ></i>
        <i class="pi pi-exclamation-triangle" *ngIf="viewModel.hasError"></i>
      </div>

      <div *ngIf="!viewModel.isEditing">
        <span
          *ngFor="let jobRole of viewModel.authorJobRoles"
          class="jobRole"
          >{{ jobRole.role }}</span
        >
        <span
          *ngIf="viewModel.comment.attributes?.length"
          class="comment-attribute"
        >
          <!-- spamreport -->
          <i
            *ngIf="viewModel.comment.attributes.includes('spamreport')"
            class="pi pi-ban"
            [ngStyle]="{ color: '#e11d48' }"
            [pTooltip]="
              'Marked as spam by: ' +
              (viewModel.comment.metadata?.email_spamreport || []).join(', ')
            "
            tooltipPosition="top"
          ></i>

          <!-- unsubscribe -->
          <i
            *ngIf="viewModel.comment.attributes.includes('unsubscribe')"
            class="pi pi-user-minus"
            [ngStyle]="{ color: '#f97316' }"
            [pTooltip]="
              'Unsubscribed by: ' +
              (viewModel.comment.metadata?.email_unsubscribe || []).join(', ')
            "
            tooltipPosition="top"
          ></i>

          <!-- group_unsubscribe -->
          <i
            *ngIf="viewModel.comment.attributes.includes('group_unsubscribe')"
            class="pi pi-user-minus"
            [ngStyle]="{ color: '#f59e0b' }"
            [pTooltip]="
              'Group unsubscribed by: ' +
              (viewModel.comment.metadata?.email_group_unsubscribe || []).join(
                ', '
              )
            "
            tooltipPosition="top"
          ></i>

          <ng-container *ngIf="viewModel.emailStatus">
            <i
              [class]="viewModel.emailStatus.icon"
              [ngStyle]="{ color: viewModel.emailStatus.color }"
              [pTooltip]="customTooltip"
              tooltipPosition="top"
              tooltipStyleClass="email-tooltip"
            ></i>

            <ng-template #customTooltip>
              <div class="tooltip-body">
                <div *ngFor="let group of viewModel.emailStatus.tooltip">
                  <strong>{{ group.status | titlecase }}:</strong>
                  <div class="ml-2 text-sm">
                    {{ group.emails.join(', ') }}
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>

        </span>

        <span *ngIf="viewModel.smsStatus" class="comment-attribute">
          <ng-container>
            <i [class]="viewModel.smsStatus.icon" [ngStyle]="{ color: viewModel.smsStatus.color }" [pTooltip]="smsTooltip"
              tooltipPosition="top" tooltipStyleClass="email-tooltip"></i>
        
            <ng-template #smsTooltip>
              <div class="tooltip-body">
                <div *ngFor="let group of viewModel.smsStatus.tooltip">
                  <strong>{{ group.status | titlecase }}:</strong>
                  <div class="ml-2 text-sm">
                    {{ group.recipients.join(', ') }}
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </span>

        <button
          class="pi pi-reply action"
          *ngIf="!viewModel.comment.parentId"
          [disabled]="viewModel.hasError"
          (click)="
            store.dispatch(
              actions.replyButtonClicked({
                commentId: viewModel.comment.id,
              })
            )
          "
        ></button>
        <button
          class="pi pi-pen-to-square action"
          *ngIf="viewModel.canEdit"
          [disabled]="viewModel.hasError"
          (click)="
            store.dispatch(
              actions.editCommentButtonClicked({
                commentId: viewModel.comment.id,
                parentId: viewModel.comment.parentId,
              })
            )
          "
        ></button>
        <button
          class="pi pi-trash action"
          *ngIf="viewModel.canDelete"
          [disabled]="viewModel.hasError"
          (click)="
            store.dispatch(
              actions.deleteCommentButtonClicked({
                commentId: viewModel.comment.id,
                parentId: viewModel.comment.parentId,
              })
            )
          "
        ></button>

        <button
          class="action pi pi-ellipsis-v"
          *ngIf="viewModel.showMenu"
          (click)="commentMenu.toggle($event)"
        ></button>
        <p-menu
          #commentMenu
          [model]="viewModel.commentMenuItems"
          [popup]="true"
        />
      </div>
    </div>

    <p-message
      *ngIf="viewModel.hasError"
      severity="error"
      [text]="viewModel.comment.callState?.error"
    ></p-message>

    <div
      *ngIf="viewModel.comment.thread?.subject && !viewModel.comment.parentId"
      class="subject"
    >
      Subject: {{ viewModel.comment.thread?.subject }}
    </div>

    <!--
    We need to create two instances with different modules
    because quill doesnt know to reload modules
    -->
    <quill-editor
      *ngIf="!viewModel.isEditing"
      class="content viewMode"
      [ngModel]="viewModel.contents"
      [readOnly]="true"
      format="object"
      [modules]="viewModules"
    ></quill-editor>

    <quill-editor
      *ngIf="viewModel.isEditing"
      class="content editMode"
      format="object"
      [readOnly]="false"
      [ngModel]="viewModel.commentEditContents"
      (ngModelChange)="
        store.dispatch(
          actions.commentEditContentChanged({
            commentId: viewModel.comment.id,
            content: $event,
          })
        )
      "
      [modules]="viewModel.editCommentModules"
      (onEditorCreated)="handleEditorCreated($event)"
      appQuillTemplateVariableToolbar
      [editorId]="'EditComment' + viewModel.comment.id"
      [templatesLocations]="viewModel.templatesLocations"
      [variablesLocation]="variablesLocation"
    ></quill-editor>

    <ng-container *ngTemplateOutlet="commentAttachments"></ng-container>

    <div *ngIf="viewModel.isEditing" class="commentButtons">
      <p-button
        label="Save Comment"
        severity="primary"
        (click)="
          store.dispatch(
            actions.saveCommentEditsButtonClicked({
              commentId: viewModel.comment.id,
              parentId: viewModel.comment.parentId,
            })
          )
        "
      />
      <p-button
        label="Cancel"
        severity="secondary"
        (click)="
          store.dispatch(
            actions.cancelCommentEditsButtonClicked({
              commentId: viewModel.comment.id,
            })
          )
        "
      />
    </div>
    <!-- <span
      class="preserve-whitespace"
    >{{ contents }}</span> -->
    <p-button
      (click)="
        store.dispatch(
          actions.toggleExpandRepliesButtonClicked({
            commentId: viewModel.comment.id,
          })
        )
      "
      class="replyExpander"
      [link]="true"
      *ngIf="viewModel.replies.length && !viewModel.comment.parentId"
    >
      {{ viewModel.isRepliesExpanded ? 'Collapse' : 'Expand' }} Replies
    </p-button>

    <div
      class="replies"
      *ngIf="
        !viewModel.comment.parentId &&
        viewModel.isRepliesExpanded &&
        viewModel.replies.length
      "
    >
      <!--
        Show replies here but only if we are the parent
      -->
      <app-job-comment
        *ngFor="let reply of viewModel.comment.replies; trackBy: identifyReply"
        class="comment"
        [class.system]="viewModel.comment.author"
        [class.topLevel]="false"
        [comment]="reply"
      ></app-job-comment>
    </div>

    <div
      class="content-reply"
      *ngIf="
        !viewModel.comment.parentId &&
        viewModel.isRepliesExpanded &&
        !viewModel.hasError
      "
    >
      <input
        class="replyInput"
        pInput
        *ngIf="!viewModel.replyOpened"
        placeholder="Reply..."
        (focus)="
          store.dispatch(
            actions.replyInputFocused({
              commentId: viewModel.comment.id,
            })
          )
        "
      />
      <quill-editor
        *ngIf="viewModel.replyOpened"
        class="content editMode"
        [readOnly]="viewModel.mutating || viewModel.hasError"
        [ngModel]="viewModel.replyContents"
        (ngModelChange)="
          store.dispatch(
            actions.replyInputContentChanged({
              commentId: viewModel.comment.id,
              content: $event,
            })
          )
        "
        (onEditorCreated)="
          handleReplyEditorCreated($event, viewModel.comment.id)
        "
        format="object"
        [modules]="viewModel.addReplyModules"
        appQuillTemplateVariableToolbar
        [editorId]="'ReplyTo' + viewModel.comment.id"
        [templatesLocations]="viewModel.templatesLocations"
        [variablesLocation]="variablesLocation"
      ></quill-editor>

      <div class="commentButtons" *ngIf="viewModel.replyOpened">
        <div class="pending-files" *ngIf="viewModel.replyPendingFiles.length">
          <div
            class="file-chip"
            *ngFor="let file of viewModel.replyPendingFiles"
          >
            <i class="pi pi-file"></i>
            <span class="file-name">{{ file.name }}</span>
            <button
              class="remove-file"
              type="button"
              [attr.aria-label]="'Remove file ' + file.name"
              (click)="
                store.dispatch(
                  actions.replyFileRemoved({
                    commentId: viewModel.comment.id,
                    fileId: file.id,
                  })
                )
              "
            >
              &times;
            </button>
          </div>
        </div>
        <p-button
          [disabled]="
            viewModel.mutating || viewModel.replyEmpty || viewModel.hasError
          "
          label="Add Comment"
          severity="primary"
          (click)="
            store.dispatch(
              actions.addReplyButtonClicked({
                commentId: viewModel.comment.id,
                parentId: viewModel.comment.parentId,
              })
            )
          "
        />
        <p-button
          [disabled]="viewModel.mutating || viewModel.hasError"
          label="Cancel"
          severity="secondary"
          (click)="
            store.dispatch(
              actions.cancelReplyButtonClicked({
                commentId: viewModel.comment.id,
              })
            )
          "
        />
      </div>
    </div>
  </div>

  <!--
    Attachments, shared by **both** comment modes.
    They used to exist only inside the `!commentMode.system` branch, so a system comment carrying
    files rendered nothing at all. That went unnoticed while only humans attached things — the crew
    navigator now posts step photos on a `mode: 'System'` comment (item 3 / #43), and they were
    stored correctly and displayed nowhere. A template rather than a second copy, so the two modes
    cannot drift.
  -->
  <ng-template #commentAttachments>
    <div
      class="pending-files"
      *ngIf="viewModel.comment.artifacts?.length && !viewModel.isEditing"
    >
      <!-- A button, not a div: this chip is the only route to a comment's attachments, which now
           include the crew photos the navigator posts onto system comments. As a div it had a click
           handler but no tabindex, role or key handler, so it was unreachable by keyboard. -->
      <button
        type="button"
        class="file-chip"
        *ngFor="let artifact of viewModel.comment.artifacts"
        (click)="
          store.dispatch(actions.fileChipClicked({ artifact: artifact }))
        "
        [class.active]="artifact.url || artifact.signedUrl"
      >
        <i class="pi pi-file"></i>
        <span class="file-name">{{ artifact.name }}</span>
      </button>
    </div>
  </ng-template>
</ng-container>
